export const POSTS_QUERY_KEY = ["posts"];
export const COMMENTS_QUERY_KEY = ["postComments"];
export const SAVED_POSTS_QUERY_KEY = "savedPosts";
export const REACTIONS_QUERY_KEY = "reactions";
export const TAGS_QUERY_KEY = ["tags"];
export const POSTS_BY_TAG_QUERY_KEY = (tag: string) => [...POSTS_QUERY_KEY, "tag", tag];
export const CURRENT_USER_QUERY_KEYS = {
  CURRENT_USER_POSTS: ["currentUserPosts"],
  CURRENT_USER_PHOTOS: ["currentUserPhotos"],
  CURRENT_USER_DOCUMENTS: ["currentUserDocuments"],
};
